import { decodeToken } from "./decodeToken";
export function isTokenValid(token) {
  const tokenPayload = decodeToken(token);
  if (!tokenPayload) {
    return false;
  }
  const {
    exp
  } = tokenPayload;
  const expirationDate = new Date(exp * 1000);
  return expirationDate >= new Date();
}
//# sourceMappingURL=isTokenValid.js.map